import React, { createContext, useState, useEffect } from "react";

export const LoginContext = createContext();

export const LoginProvider = (props) => {
  const getLogin = (isLoginState) => {
    const obj = JSON.parse(localStorage.getItem("login"));
    if (isLoginState) {
      if (obj === null || obj.userInfo === undefined) {
        return false;
      } else {
        if (obj.userInfo.vitrin === undefined) {
          return false;
        } else {
          const exist = obj.userInfo.vitrin.findIndex(
            (item) => parseInt(item.vitrinCode) === props.id
          );
          if (exist !== -1) {
            return true;
          } else {
            return false;
          }
        }
      }
    } else {
      if (obj === null || obj.userInfo === undefined) {
        return {
          mobile: "",
          name: "",
          dastresi: "",
          darsad: "",
          isModir: "",
          vitrinCode: "",
          vitrin: [],
        };
      } else {
        if (obj.userInfo.vitrin === undefined) {
          return {
            mobile: obj.userInfo.mobile,
            name: obj.userInfo.name,
            dastresi: obj.userInfo.dastresi,
            darsad: obj.userInfo.darsad,
            isModir: obj.userInfo.isModir,
            vitrinCode: obj.userInfo.vitrinCode,
            vitrin: [],
          };
        } else {
          const vitrin = [...obj.userInfo.vitrin];
          const exist = vitrin.findIndex(
            (item) => parseInt(item.vitrinCode) === props.id
          );
          if (exist !== -1) {
            return {
              mobile: obj.userInfo.mobile,
              name: obj.userInfo.name,
              dastresi: vitrin[exist].dastresi,
              darsad: vitrin[exist].darsad,
              isModir: vitrin[exist].isModir,
              vitrinCode: vitrin[exist].vitrinCode,
              vitrin: vitrin,
            };
          } else {
            return {
              mobile: obj.userInfo.mobile,
              name: obj.userInfo.name,
              dastresi: obj.userInfo.dastresi,
              darsad: obj.userInfo.darsad,
              isModir: obj.userInfo.isModir,
              vitrinCode: obj.userInfo.vitrinCode,
              vitrin: vitrin,
            };
          }
        }
      }
    }
  };

  const [loginState, setLoginState] = useState(getLogin(true));

  const [userInfo, setUserInfo] = useState(getLogin(false));

  useEffect(() => {
    if (loginState && userInfo.mobile !== undefined) {
      const form = new FormData();
      form.append("check_dastresi", 1);
      form.append("vitrinCode", userInfo.vitrinCode);
      form.append("mobile", userInfo.mobile);
      form.append("isModir", userInfo.isModir ? 1 : 0);
      const req = new Request(
        "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
        {
          method: "POST",
          body: form,
        }
      );
      fetch(req)
        .then((res) => res.json())
        .then((data) => {
          if (data.result === true) {
            const loginObj = JSON.parse(localStorage.getItem("login"));
            const vitrin = [...loginObj.userInfo.vitrin];
            const obj = {
              mobile: data.data.mobile,
              name: data.data.name,
              vitrinCode: data.data.vitrinCode,
              dastresi: data.data.dastresi,
              darsad: data.data.darsad,
              isModir: data.data.isModir,
              vitrin: vitrin,
            };
            setUserInfo(obj);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, []);

  useEffect(() => {
    const obj = {
      loginState: loginState,
      userInfo: userInfo,
    };
    localStorage.setItem("login", JSON.stringify(obj));
  }, [loginState, userInfo]);

  const login = (user) => {
    setLoginState(true);
    const loginObj = JSON.parse(localStorage.getItem("login"));
    // let vitrin = [];
    // if (user.mobile === loginObj.userInfo.mobile) {
    //   vitrin = [...loginObj.userInfo.vitrin];
    //   const exist = vitrin.findIndex(
    //     (item) => item.vitrinCode === user.vitrinCode
    //   );
    //   if (exist === -1) {
    //     const vitrinObj = {
    //       vitrinCode: user.vitrinCode,
    //       dastresi: user.dastresi,
    //       darsad: user.darsad,
    //       isModir: user.isModir,
    //     };
    //     vitrin.push(vitrinObj);
    //   }
    // } else {
    //   const vitrinObj = {
    //     vitrinCode: user.vitrinCode,
    //     dastresi: user.dastresi,
    //     darsad: user.darsad,
    //     isModir: user.isModir,
    //   };
    //   vitrin.push(vitrinObj);
    // }
    const obj = {
      mobile: user.mobile,
      name: user.name,
      vitrinCode: user.vitrinCode,
      dastresi: user.dastresi,
      darsad: user.darsad,
      isModir: user.isModir,
      vitrin: user.vitrin,
    };
    setUserInfo(obj);
  };

  // const logout = () => {
  //   setLoginState(false);
  //   const loginObj = JSON.parse(localStorage.getItem("login"));
  //   const vitrin = [...loginObj.userInfo.vitrin];
  //   const index = vitrin.findIndex(
  //     (item) => parseInt(item.vitrinCode) === props.id
  //   );
  //   vitrin.splice(index, 1);
  //   const obj = {
  //     mobile: loginObj.userInfo.mobile,
  //     name: loginObj.userInfo.name,
  //     vitrin: vitrin,
  //   };
  //   setUserInfo(obj);
  // };

  const logout = () => {
    setLoginState(false);
    setUserInfo({});
  };

  return (
    <LoginContext.Provider
      value={{
        loginState: loginState,
        login: login,
        logout: logout,
        userInfo: userInfo,
      }}
    >
      {props.children}
    </LoginContext.Provider>
  );
};
